import React, { useState, useEffect, useCallback } from 'react';
import Icon from './Icon';
import { toast } from './ToastProvider';
import { apiFetch } from '../config/api';
import '../styles/B2BTrainings.css';

const TOPICS = [
  { id:'t1', group:'Techniki fryzjerskie', name:'Strzyżenie meskie zaawansowane', duration:'1 dzień',  level:'Zaawansowany' },
  { id:'t2', group:'Techniki fryzjerskie', name:'Stylizacja brody i wąsów',        duration:'0.5 dnia', level:'Podstawowy' },
  { id:'t3', group:'Techniki fryzjerskie', name:'Koloryzacja i balayage',          duration:'2 dni',   level:'Zaawansowany' },
  { id:'t4', group:'Techniki fryzjerskie', name:'Keratynowe prostowanie',          duration:'1 dzień', level:'Średni' },
  { id:'t5', group:'Pielęgnacja',          name:'Diagnostyka i pielęgnacja skalpu',duration:'1 dzień', level:'Średni' },
  { id:'t6', group:'Pielęgnacja',          name:'Zabiegi nawilżające i proteinowe',duration:'0.5 dnia',level:'Podstawowy' },
  { id:'t7', group:'Standardy sieci',      name:'Obsługa klienta HAIRKUS',        duration:'0.5 dnia',level:'Obowiązkowy' },
  { id:'t8', group:'Standardy sieci',      name:'Bezpieczeństwo i higiena pracy', duration:'0.5 dnia',level:'Obowiązkowy' },
  { id:'t9', group:'Zarządzanie',          name:'Zarządzanie salonem i teamem',   duration:'1 dzień', level:'Dla kierowników' },
  { id:'t10',group:'Nowe trendy',          name:'Trendy 2025 - cut & color',       duration:'1 dzień', level:'Dla wszystkich' },
];

const LEVEL_CFG = {
  'Podstawowy':    { color:'#10b981', bg:'#d1fae5' },
  'Średni':        { color:'#3b82f6', bg:'#dbeafe' },
  'Zaawansowany':  { color:'#8b5cf6', bg:'#ede9fe' },
  'Obowiązkowy':   { color:'#ef4444', bg:'#fee2e2' },
  'Dla kierowników':{ color:'#f59e0b', bg:'#fef3c7' },
  'Dla wszystkich':{ color:'#6366f1', bg:'#e0e7ff' },
};

const STATUS_CFG = {
  pending:   { bg:'#fef3c7', color:'#92400e', label:'Oczekuje',      icon:'clock'     },
  approved:  { bg:'#d1fae5', color:'#065f46', label:'Zatwierdzone',  icon:'confirmed' },
  rejected:  { bg:'#fee2e2', color:'#991b1b', label:'Odrzucone',     icon:'rejected'  },
  completed: { bg:'#ede9fe', color:'#4c1d95', label:'Zrealizowane',  icon:'check'     },
};

const EMPTY_FORM = {
  topicId: '', customTopic: '', employeeNames: '',
  employeeCount: 1, preferredDate: '', format: 'Stacjonarnie w salonie', notes: '',
};

const TrainingsPanel = ({ user }) => {
  const [trainings, setTrainings] = useState([]);
  const [tab,       setTab]       = useState('list'); 
  const [form,      setForm]      = useState(EMPTY_FORM);
  const [submitting,setSubmitting]= useState(false);
  const [expanded,  setExpanded]  = useState(null);

  const load = useCallback(async () => {
    if (!user?.id) return;
    try {
      const data = await apiFetch('/b2b/trainings');
      setTrainings(data || []);
    } catch { }
  }, [user?.id]);

  useEffect(() => { load(); }, [load]);

  const selectedTopic = TOPICS.find(t => t.id === form.topicId);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.topicId && !form.customTopic) {
      toast.error('Wybierz lub wpisz temat szkolenia'); return;
    }
    if (!form.employeeNames.trim()) {
      toast.error('Podaj imiona pracowników'); return;
    }

    if (form.preferredDate) {
      const year = parseInt(form.preferredDate.split('-')[0]);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const selected = new Date(form.preferredDate);
      if (year > 2100 || year < 2024 || selected < today) {
        toast.error('Podaj prawidłową datę (nie może być z przeszłości)');
        return;
      }
    }

    setSubmitting(true);
    try {
      await apiFetch('/b2b/trainings', {
        method: 'POST',
        body: JSON.stringify({
          topicName:     selectedTopic?.name || form.customTopic,
          topicGroup:    selectedTopic?.group || 'Własny temat',
          employeeNames: form.employeeNames,
          employeeCount: form.employeeCount,
          format:        form.format,
          preferredDate: form.preferredDate || null,
          notes:         form.notes,
        }),
      });
      setForm(EMPTY_FORM);
      setTab('list');
      load();
      toast.success('Wniosek szkoleniowy wysłany! Administrator skontaktuje się z Tobą wkrótce.');
    } catch (err) {
      toast.error(err.message || 'Błąd podczas wysyłania wniosku');
    } finally {
      setSubmitting(false);
    }
  };

  const pending   = trainings.filter(t => t.status === 'pending').length;
  const approved  = trainings.filter(t => t.status === 'approved').length;
  const completed = trainings.filter(t => t.status === 'completed').length;

  const today = new Date().toISOString().split('T')[0];

  return (
    <div className="trainings-wrapper">
      {/* Nagłówek */}
      <div className="trainings-header">
        <div className="trainings-header-left">
          <div className="trainings-header-icon"><Icon name="staff" color="white" size="xl" /></div>
          <div>
            <h2>Szkolenia Pracowników</h2>
            <p>Rozwijaj kompetencje zespołu ze standardami HAIRKUS</p>
          </div>
        </div>
        <button className={`trainings-new-btn ${tab==='new'?'active':''}`}
          onClick={() => setTab(tab === 'new' ? 'list' : 'new')}>
          {tab === 'new'
            ? <><Icon name="close" style={{marginRight:'7px'}} />Anuluj</>
            : <><Icon name="add"   style={{marginRight:'7px'}} />Nowy wniosek</>
          }
        </button>
      </div>

      {/* Pasek statystyk */}
      <div className="trainings-stats-bar">
        {[
          {label:'Złożone wnioski', val: trainings.length, icon:'application', color:'#1e3c72'},
          {label:'Oczekujące',     val: pending,           icon:'clock',       color:'#f59e0b'},
          {label:'Zatwierdzone',   val: approved,          icon:'confirmed',   color:'#10b981'},
          {label:'Zrealizowane',   val: completed,         icon:'check',       color:'#6366f1'},
        ].map(s => (
          <div key={s.label} className="trainings-stat">
            <Icon name={s.icon} color={s.color} size="lg" />
            <div>
              <strong style={{color:s.color, fontSize:'1.4em'}}>{s.val}</strong>
              <span>{s.label}</span>
            </div>
          </div>
        ))}
      </div>

      {/* Formularz nowego wniosku */}
      {tab === 'new' && (
        <form onSubmit={handleSubmit} className="trainings-form">
          <h3><Icon name="add" style={{marginRight:'8px'}} />Wniosek o szkolenie</h3>

          {/* Wybór tematu */}
          <div className="trainings-topics-grid">
            {TOPICS.map(t => {
              const lc = LEVEL_CFG[t.level] || {};
              const active = form.topicId === t.id;
              return (
                <div key={t.id}
                  className={`trainings-topic-card ${active?'selected':''}`}
                  onClick={() => setForm(f => ({...f, topicId: active ? '' : t.id, customTopic:''}))}
                >
                  <div className="trainings-topic-group">{t.group}</div>
                  <div className="trainings-topic-name">{t.name}</div>
                  <div className="trainings-topic-meta">
                    <span><Icon name="clock" style={{marginRight:'4px',fontSize:'0.8em'}} />{t.duration}</span>
                    <span className="level-badge" style={{background:lc.bg,color:lc.color}}>{t.level}</span>
                  </div>
                  {active && <div className="trainings-topic-check"><Icon name="check" color="white" /></div>}
                </div>
              );
            })}
          </div>

          {/* Własny temat */}
          <div className="trainings-field">
            <label>Lub wpisz własny temat:</label>
            <input
              value={form.customTopic}
              onChange={e => setForm(f => ({...f, customTopic: e.target.value, topicId:''}))}
              placeholder="Np. Techniki farbowania ombre..."
              className="trainings-input"
            />
          </div>

          <div className="trainings-form-grid">
            <div className="trainings-field">
              <label><Icon name="users" style={{marginRight:'5px'}} />Uczestnicy szkolenia *</label>
              <textarea
                value={form.employeeNames}
                onChange={e => setForm(f => ({...f, employeeNames: e.target.value}))}
                placeholder="np. Jan Kowalski, Anna Nowak, Marek Wiśniewski"
                required rows={2} className="trainings-textarea"
              />
            </div>
            <div className="trainings-field">
              <label><Icon name="stats" style={{marginRight:'5px'}} />Liczba uczestników</label>
              <input
                type="number" min="1" max="20"
                value={form.employeeCount}
                onChange={e => setForm(f => ({...f, employeeCount: parseInt(e.target.value)||1}))}
                className="trainings-input"
              />
            </div>
            <div className="trainings-field">
              <label><Icon name="calendar" style={{marginRight:'5px'}} />Preferowana data</label>
              <input
                type="date"
                value={form.preferredDate}
                onChange={e => setForm(f => ({...f, preferredDate: e.target.value}))}
                min={today}
                className="trainings-input"
              />
            </div>
            <div className="trainings-field">
              <label><Icon name="location" style={{marginRight:'5px'}} />Format szkolenia</label>
              <select value={form.format} onChange={e => setForm(f => ({...f, format: e.target.value}))} className="trainings-input">
                <option value="Stacjonarnie w salonie">Stacjonarnie w salonie</option>
                <option value="Centrum szkoleniowe HAIRKUS">Centrum szkoleniowe HAIRKUS</option>
                <option value="Online (live)">Online (live)</option>
              </select>
            </div>
          </div>

          <div className="trainings-field">
            <label>Dodatkowe uwagi</label>
            <textarea
              value={form.notes}
              onChange={e => setForm(f => ({...f, notes: e.target.value}))}
              placeholder="Poziom zaawansowania, specjalne potrzeby, preferowany trener..."
              rows={2} className="trainings-textarea"
            />
          </div>

          {/* Pole podsumowania */}
          {(form.topicId || form.customTopic) && (
            <div className="trainings-summary-box">
              <h4>Podsumowanie wniosku</h4>
              <div className="trainings-summary-grid">
                <span><Icon name="service" style={{marginRight:'6px',color:'#1e3c72'}} /><strong>Temat:</strong> {selectedTopic?.name || form.customTopic}</span>
                <span><Icon name="users" style={{marginRight:'6px',color:'#1e3c72'}} /><strong>Uczestnicy:</strong> {form.employeeCount} os.</span>
                {form.preferredDate && <span><Icon name="calendar" style={{marginRight:'6px',color:'#1e3c72'}} /><strong>Data:</strong> {new Date(form.preferredDate).toLocaleDateString('pl-PL')}</span>}
                <span><Icon name="location" style={{marginRight:'6px',color:'#1e3c72'}} /><strong>Format:</strong> {form.format}</span>
              </div>
            </div>
          )}

          <div className="trainings-form-actions">
            <button type="button" className="trainings-cancel-btn" onClick={() => setTab('list')}>Anuluj</button>
            <button type="submit" className="trainings-submit-btn" disabled={submitting}>
              {submitting
                ? <><Icon name="refresh" style={{marginRight:'7px'}} />Wysyłanie...</>
                : <><Icon name="send"    style={{marginRight:'7px'}} />Wyślij wniosek</>
              }
            </button>
          </div>
        </form>
      )}

      {/* Lista */}
      {tab === 'list' && (
        <div className="trainings-list-wrap">
          {trainings.length === 0 ? (
            <div className="trainings-empty">
              <Icon name="staff" color="#d1d5db" size="3x" />
              <h3>Brak wniosków szkoleniowych</h3>
              <p>Zaplanuj szkolenie dla swojego zespołu już dziś</p>
              <button className="trainings-new-btn" onClick={() => setTab('new')}>
                <Icon name="add" style={{marginRight:'7px'}} />Złóż pierwszy wniosek
              </button>
            </div>
          ) : (
            <div className="trainings-entries">
              {[...trainings].reverse().map(t => {
                const sc = STATUS_CFG[t.status] || STATUS_CFG.pending;
                const isOpen = expanded === t.id;
                return (
                  <div key={t.id} className="trainings-entry">
                    <div className="trainings-entry-head" onClick={() => setExpanded(isOpen ? null : t.id)}>
                      <div className="trainings-entry-main">
                        <div className="trainings-entry-group">{(t.topic_group || t.topicGroup)}</div>
                        <strong className="trainings-entry-name">{(t.topic_name || t.topicName)}</strong>
                        <span className="trainings-entry-date">
                          <Icon name="calendar" style={{marginRight:'4px',fontSize:'0.85em'}} />
                          Złożono: {new Date(t.submitted_at || t.submittedAt || Date.now()).toLocaleDateString('pl-PL')}
                        </span>
                      </div>
                      <div className="trainings-entry-right">
                        <span className="trainings-status-pill" style={{background:sc.bg,color:sc.color}}>
                          <Icon name={sc.icon} style={{marginRight:'5px',fontSize:'0.85em'}} />{sc.label}
                        </span>
                        <Icon name={isOpen?'chevron-up':'chevron-down'} color="#9ca3af" />
                      </div>
                    </div>
                    {isOpen && (
                      <div className="trainings-entry-details">
                        <div className="trainings-detail-grid">
                          <div><label>Uczestnicy</label><p>{(t.employee_names || t.employeeNames)}</p></div>
                          <div><label>Liczba osób</label><p>{(t.participants || t.employee_count || t.employeeCount || 1)}</p></div>
                          <div><label>Format</label><p>{(t.format || 'Stacjonarne')}</p></div>
                          {(t.preferred_date || t.preferredDate) && <div><label>Pref. data</label><p>{new Date(t.preferred_date || t.preferredDate).toLocaleDateString('pl-PL')}</p></div>}
                          {t.notes && <div style={{gridColumn:'1/-1'}}><label>Uwagi</label><p>{t.notes}</p></div>}
                        </div>
                        {t.status === 'approved' && (
                          <div className="trainings-approved-note">
                            <Icon name="confirmed" color="#059669" style={{marginRight:'8px'}} />
                            Wniosek zatwierdzony przez administratora. Oczekuj na kontakt w celu ustalenia szczegółów.
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default TrainingsPanel;